// CORE-1735 slice 17 (D-120, QA V06) — Live icon «music» from the published set v4.2
// (Confluence 110461314, archive reference-icons-v4.2): geometry as shipped, strokes 1.8,
// paint from the caller (`color` — solid or an ink gradient reference), the inner
// highlight through `filter` (the toolbar's «live-polish»), the slash cut by `cut`.
import React from 'react';
import Svg, { G, Ellipse, Path } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Note: React.FC<LiveGlyphProps> = ({ size, color, filter }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <G filter={filter} fill={color} fillRule="evenodd">
    <Path d="M8 5l13-3v15h-2V6L10 8v12H8Z" fill={color} />
    <Ellipse cx={6.5} cy={20} rx={3.5} ry={3} fill={color} />
    <Ellipse cx={17.5} cy={17} rx={3.5} ry={3} fill={color} />
    </G>
  </Svg>
);
